<template>
  <div style="position:relative">
    <div class="tooltip" v-if="hover && settings.tooltip" :style="{'left': clampX(hover.x) + 'px', 'top': height/2+10 + 'px'}">
      <div class="tooltip_headline">{{hover.date}}</div>
      <table>
        <tr v-for="(row, index) in hover.data" :key="'row'+index">
        <!-- <td>{{row[0]}}:</td> -->
          <td style="font-weight:bold">{{format(row[1])}}</td> 
        </tr>
      </table>
    </div>
    <svg width="100%" :height="settings.height+16" ref="svg">

      <defs>
        <linearGradient :id="'gradient'+settings.colors[0]" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" :style="'stop-color:'+settings.colors[0]+';stop-opacity:.8'" />
          <stop offset="100%" :style="'stop-color:'+settings.colors[0]+';stop-opacity:0'" />
        </linearGradient>
      </defs>
      <!-- <ellipse cx="200" cy="70" rx="85" ry="55" fill="url(#gradient)" /> -->

      <!-- Legende -->

      <g class="legend" v-if="settings.showLegend">
        <circle v-for="(item, index) in settings.legend" :key="'legend-dot'+index"
            :cx=5
            :cy=10+index*12 
            r="5"
            :fill="settings.colors[index]"
            :stroke="settings.colors[index]"
        />
        <text v-for="(item, index) in settings.legend" :key="'legend-text'+index"
          :x=15
          :y=15+index*12
          text-anchor="start"
          fill="#666"
          style="font-size:12px">
          {{settings.legend[index]}}
        </text>
      </g>

      <!-- Grid -->
      <g class="grid" v-if="settings.grid">
        <g v-for="(n, index) in grid.slice(1)" :key="'ygrid'+index">
          <text 
            :x="0" 
            :y="y(n)+5"
            text-anchor="start"
            class="grid-label">
            {{String(n).replace('.',',')}}
          </text>
          <!-- <line 
            :x1="0" :y1="y(n)"
            :x2="width" :y2="y(n)"
            stroke="#efefef"
            stroke-width="1"
            fill="none" /> -->
        </g>
      </g>

      <!-- Area -->
      <polyline v-if="showArea"
        :points="area"
        :fill="'url(#gradient'+settings.colors[0]+')'"
      />
      <!-- :style="'fill:'+settings.colors[0]+';opacity:.5;stroke-width:0'"  -->

      <!-- Hover Line -->
      <line v-if="hover && settings.tooltip"
        :x1="hover.x" :y1="0"
        :x2="hover.x" :y2="settings.height"
        stroke="#ddd" 
      />
      <!-- :x1="hover.x" :y1="y(0)"
        :x2="hover.x" :y2="height" -->

      <!-- X-Axis -->
      <!-- <line 
        :x1="0" :y1="y(0)+1"
        :x2="width" :y2="y(0)+1"
        stroke="#ddd" /> -->
      <rect 
        :x="0" :y="settings.height"
        :width="width"
        fill="#ddd" 
        class="energy-baseline"
        height=1
        />

      <!--  X-Axis Labels  -->
      <text 
          :x="0" 
          :y="settings.height+15" 
          text-anchor="start"
          class="grid-label x"
          :style="{'fontSize': settings.fontSize + 'px'}">
        <tspan v-if="settings.axisLabels">
          {{settings.axisLabels[0]}}
        </tspan>
        <tspan v-else>
          {{data[1][0]}}
        </tspan>
      </text>
      <text 
          :x="width" 
          :y="settings.height+15" 
          text-anchor="end"
          class="grid-label x"
          :style="{'fontSize': settings.fontSize + 'px'}">
        <tspan v-if="settings.axisLabels">
          {{settings.axisLabels[1]}}
        </tspan>
        <tspan v-else>
          {{data.slice(-1)[0][0]}}
        </tspan>
      </text>
      <!-- formatDate(xRange[1]) -->

      <!-- Line -->
      <g>
        <polyline v-for="(line, index) in lines" :key="'line'+index"
          :points="line"
          :style="'fill:none;stroke:'+settings.colors[index]+';stroke-width:'+settings.lineWidth" />
        <!-- <circle v-for="(dot, i) in dataUser.progresses.slice(-1)" :key="'dot'+i"
          :cx="x(dot.date)" :cy="y(dot.total)" r="3"  fill="#e05400" 
          @mouseover="mouseover(dot, dataUser.username)" @mouseleave="mouseleave()"/>
        <g v-for="(dot, i) in dataUser.progresses.slice(0,-1)" :key="'dott'+i">
          <circle 
            :cx="x(dot.date)" :cy="y(dot.total)" r="6"  fill="transparent" 
            @mouseover="mouseover(dot, dataUser.username)" @mouseleave="mouseleave()"/>
          <text 
            :x="x(dot.date)" :y="y(dot.total)"
            text-anchor="start">
            {{dataUser.username}}
          </text>
        </g> -->
      </g>

      <!-- Hover Dot -->
      <g v-if="hover && settings.tooltip">
        <circle v-for="(y, index) in hover.y" :key="'dot'+index"
            :cx="hover.x" 
            :cy="y" 
            r="3"
            :fill="settings.colors[index]"
        />
      </g>

      <!-- End Dot -->
      <g v-if="settings.dot">
        <circle v-for="(line, index) in lines" :key="'end-dot'+index"
            :cx="x(data.length-1)" 
            :cy="y(data.slice(-1)[0][index+1])"
            r="3"
            :fill="settings.colors[index]"
            stroke="#fff"
        />
      </g>

      <!-- Number -->
      <text v-for="(txt, index) in lines" :key="'row'+index"
        :x="x(data.length-1)+4" 
        :y="Math.min(y(data.slice(-1)[0][index+1])+5, settings.height-4)" 
        text-anchor="start"
        class="number"
        :fill="settings.colors[index]"
        font-size="16"
        style="font-size: 16px"
        font-weight="bold">
        {{format(data.slice(-1)[0][index+1])}}
      </text>

    <!--  <text 
        :x="x(data.length-1)+4" 
        :y="Math.min(y(data.slice(-1)[0][2])+5, settings.height-4)" 
        text-anchor="start"
        class="number"
        :fill="settings.colors[1]"
        font-size="16"
        style="font-size: 16px"
        font-weight="bold">
        {{format(data.slice(-1)[0][2])}}
      </text>-->


      <!-- Hover Area -->
      <rect 
        x="0" y="0"
        :width="width"
        :height="settings.height"
        fill="transparent"
        @mouseover="mouseover($event)" 
        @mousemove="mouseover($event)"
        @touchmove="mouseover($event)" 
        @mouseleave="mouseleave()"
      />

    </svg>
  </div>
</template>

<script>
import {scaleLinear, bisectRight} from 'd3' //scaleTime, format, 
import debounce from 'debounce'
//import * as d3 from 'd3'
// import {eachDayOfInterval} from 'date-fns' //, formatDistance, formatRelative, subDays  format as formatDate, 

export default {
  name: 'LineChart',
  props: {
    data: { type: Array, default: () => [[1,0],[2,9],[3,1],[4,8],[5,2],[6,7],[7,3],[8,6],[9,4],[10,5]] },
    options: Object,
    yRange: { type: Array }, //, default: () => [0,10] 
    // xRange: Array,
    colors: { type: Array, default: () => ["#577bb7","#d13d3d","#6FA746","#ed7d38","#a284c7","#edbf57","#c1c1c1","#88a3d6","#f36969","#a5ce81","#ffa46e","#c0a4e2","#ffd882","#d5d5d5",] },
    height: { type: Number, default: 200 },
    // grid: { type: Boolean, default: true }
  },
  data () {
    return {
      // padding: { left: 25, right: 5, top: 15, },
      width: 600,
      // height: 300,
      dragging: false,
      hover: null,
      barMargin: 4,
      showNames: false,
      maxTicks: 5,
      defaultOptions: {
        // yRange: [0,10]
        colors: ["#577bb7","#d13d3d","#6FA746","#ed7d38","#a284c7","#edbf57","#c1c1c1","#88a3d6","#f36969","#a5ce81","#ffa46e","#c0a4e2","#ffd882","#d5d5d5",],
        height: 200,
        grid: true,
        tooltip: true,
        dot: false,
        fontSize: 14,
        lineWidth: 2.5,
        showArea: true,
        showLegend: false,
        legend: ["Legende 1", "Legende 2"]
      }
    }
  },
  methods: {
    format (x) {
      return String(x).replace('.',',')
    },
    formatDate (str) {
      const date = new Date(str)
      return date.toLocaleDateString()
    },
    y (val) {
      var heightval = 20
      if (this.settings.showLegend== true) {
            heightval = 20 + 10*this.settings.legend.length;
    }
      const x = scaleLinear()
        .domain(this.yRangeComputed)
        .range([this.settings.height, heightval])
      return x(val)
    },
    x (val) {
      const x = scaleLinear()
        // .domain([new Date(this.xRange[0]), new Date(this.xRange[1])])
        .domain([0, this.data.length-1])
        .range([this.padding.left, this.width-this.padding.right])
      return x(val)
    },
    index (val) {
      const x = scaleLinear()
        .domain([this.padding.left, this.width-this.padding.right])
        .range([1, this.data.length])
      // console.log(Math.round(x(val+1)))
      return Math.max(Math.round(x(val+1)),1)
    },
    fitProjection () {
      this.width = this.$refs.svg.getBoundingClientRect().width
    },
    mouseover (event) {
      let x = 0
      if(event.layerX) { // Mouse
        x = event.layerX
      } else { // Touch
        let rect = event.target.getBoundingClientRect()
        x = event.targetTouches[0].pageX - rect.left
      }
      let row = this.data[this.index(x)] 
      // console.log(this.index(x), row)
      // console.log(event, x, this.index(x), this.data.length, this.data.indexOf(row))
      // let showDate = row[0]
      // var splits = showDate.split('-', 3);    // split() looks for spaces in a string and returns the first 3 splits that it finds. 
      // var splityear = splits[0].substring(splits[0].length-2, splits[0].length);
      // showDate = splits[2]+"."+splits[1]+"."+splityear


      if(this.data.indexOf(row)>=0) {
        this.hover = {
          x: this.x(this.data.indexOf(row)-1),
          y: row.slice(1).map( el => this.y(el)),
          date: row[0],
          data: row.slice(1).map( (row, index) => {
              return [this.data[0][index+1], row]
          })
        }
      } else {
        this.hover = null
      }
    },
    mouseleave () {
      this.hover = null
    },
    clampX (x) {
      let min = 50
      let max = this.width-50
      return x <= min ? min : x >= max ? max : x;
    },
    toggleNames () {
      this.showNames = !this.showNames
    },
    rotate (angle, originX, originY) {
      return 'rotate('+angle+','+originX+','+originY+')'
    },
    
  },
  mounted () {
    this.fitProjection()
    window.addEventListener('resize', debounce(this.fitProjection, 250))
    setTimeout(() => { this.fitProjection() }, 2000)
  },
  updated () {
    this.fitProjection()
    // console.log(this.tickSize(888, 7))
  },
  computed: {
    settings: function () {
      return Object.assign(this.defaultOptions, this.options)
    },
    padding: function () {
      let padding = {}
      if(this.settings.grid) {
        padding = { left: 25, right: 5, top: 15 }
      } else {
        padding = { left: 0, right: 5, top: 3 }
      }
      if(this.settings.showNumber) {
        let stringLength = String(this.data.slice(-1)[0][1]).length
        padding.right = stringLength*10//50
      }

      return padding
    },
    points: function () {
      return this.data.slice(1) //User.progresses
        .map((row, index) => {
          var point = [this.x(index), this.y(row[1])]
          return point[0] + "," + point[1]
        })
        .join(" ")
    },
    lines: function () {
      let lines = []
      this.data[0].slice(1).forEach( (column, seriesIndex) => { // iterate over series
        let line = this.data.slice(1)
          .map((row, rowIndex) => {
            var point = [this.x(rowIndex), this.y(row[seriesIndex+1])]
            // console.log(this.y(row[seriesIndex+1]))
            return point[0] + "," + point[1]
          })
          .join(" ")
        lines.push(line)
      })
      return lines

      

      // let friendsPoints = []

      // this.dataFriends.forEach( friend => {
      //   let points = friend.progresses.map(row => {
      //     var point = [this.x(row.date), this.y(row.total)]
      //     return point[0] + "," + point[1]
      //   })
      //   .join(" ")

      //   friendsPoints.push(points)
      // })

      // return friendsPoints
    },
    showArea: function () {
      if (this.data[0].length == 2 && this.settings.showArea == true) {
        return true
      } else {
        return false
      }
    },
    area: function () {
      let start = this.x(0) + "," + this.y(0)
      let end = this.x(this.data.length-1) + "," + this.y(0)
      return `${start} ${this.points} ${end}`
    },
    yRangeComputed () {
      if (this.yRange) {
        return this.yRange
      } else {
        let min = Math.min.apply(Math, this.data.slice(1).map( el => el[1] ))
        if(this.settings.grid) {
          min = Math.min(min, this.grid[0])
        }
        let max = Math.max.apply(Math, this.data.slice(1).map( el => el[1] ))
        return [min, max]
        // return [0, Math.max.apply(Math, this.data.slice(1).map( el => el[1] )) ]
      }
      // return this.yRange // To-Do
      // return [0, Math.max.apply(Math, this.dataUser.progresses.map( el => el.amount )) ]
    },
    yRangeComputed2 () {
      let max = Math.max.apply(Math, this.data.slice(1).map(x=>x[1]))
      let stellen = String(parseInt(max)).length
      let power = Math.pow(10,stellen-1)
      let next = Math.ceil(max/power)*power

      return [0, next]
      // return [0, Math.max.apply(Math, this.dataUser.progresses.map( el => el.amount )) ]
    },
    max () {
      return Math.max.apply(Math, this.data.slice(1).map(x=>x[1]))
    },
    tickSize () {
      let minimum = this.max / this.maxTicks
      let magnitude = Math.pow(10, Math.floor(Math.log10(minimum)))
      let residual = minimum / magnitude
      // this table must begin with 1 and end with 10
      let table = [1, 2, 2.5, 3, 5, 6, 7, 10] // [1, 2, 1.5, 2.5, 3, 5, 7, 7.5, 10]
      let bisect = bisectRight(table, residual)
      let tick = residual < 10 ? table[bisect] : 10
      // console.log(`minimum: ${minimum}, magnitude: ${magnitude}, residual: ${residual}, bisect: ${table[bisect]}, tick: ${tick}, tick size: ${tick * magnitude}`)
      return tick * magnitude
    },
    grid () {
      let num = 10
      if(this.yRange) {
        num = (this.yRange[1]+1)/this.tickSize
      } else {
        num = (this.max+1)/this.tickSize
      }
      num = Math.ceil(num)
      return [...Array(num).keys()].map(x => x = x*this.tickSize)
    },
    // barThickness: function () {
    //   let n = eachDayOfInterval({ start: new Date(this.xRange[0]), end: new Date(this.xRange[1]) }).length
      
    //   let thickness = (this.width + this.padding.left - this.padding.right - this.barMargin*(n-1))/n
    //   return Math.min(Math.round(thickness), 16)
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // @import '@/assets/sass/variables.scss';

  .grid-label {
    font-size: 13px;
    fill: #b0b0b0;

    &.x {
      fill: #666;
    }
  }


.wealthButton {
  cursor: ns-resize;
}

.tooltip {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align:center;
  padding: 4px 10px;
  position: absolute;
  color: var(--mm-white);
  font-size: 16px;
  font-weight:regular;
  line-height: 1.1;
  background: var(--mm-grey-300);
  border-radius: 2px;
  transform: translate(-50%, -100%);
  pointer-events: none;
  -webkit-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15);
  -moz-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15);
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15);
  // text-align: center;

  em {
    font-weight: regular;
  }

  // &::after{
  //   content: '';
  //   position: absolute;
  //   left: 50%;
  //   transform: translateX(-50%);
  //   top: 100%;
  //   width: 0;
  //   height: 0;
  //   border-left: 8px solid transparent;
  //   border-right: 8px solid transparent;
  //   border-top: 8px solid #666;
  //   clear: both;
  // }

  &_headline{
    font-weight: regular!important;
    font-size:13px;
    padding-bottom: 2px;
    margin-bottom: 0;
    display: block;
    text-align:center;
  }

  ul{
    list-style: none;
    padding: 0;
    margin: 0;
  }

  table {
    border-collapse: collapse;
    margin: 0;
    padding: 0;

    tr {
      margin: 0 auto;
      padding: 0;
      white-space: nowrap;
      text-align:center;
      // border: 1px solid blue;

      td {
        margin: 0 auto;
        padding: 0;
        text-align:center;
        width:100%;
        
        &:first-of-type {
          padding-right: .2em;
        }
      }
    }
  }
}
</style>
